import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';

const _ResolveAlertRequestDtoSchema = z.object({
  id: z.number(),
  resolutionOptionIds: z.array(z.number()),
});

export type ResolveAlertRequestDto = z.infer<
  typeof _ResolveAlertRequestDtoSchema
>;

export const resolveAlert = (
  params: ResolveAlertRequestDto,
  config?: AxiosRequestConfig<ResolveAlertRequestDto>
) => {
  const { id, ...resolutionOptions } = params;

  return api.patch(`alerts/${id}/resolve`, resolutionOptions, { ...config });
};
